module.exports = __webpack_public_path__ + "static/media/kampania_500_01_A.66764b9a.png";